import { createApi } from '@/api/modules/utils'

const baseUrl = '/self_media_platform'
const api = createApi(baseUrl)

// 自建站平台
export const selfMediaPlatformApi = {
    list: api('list', 'get'),
    binding: api('binding', 'get'),
}